import type { AdditionalCost } from '@api'
import type { ColumnDef } from '@tanstack/react-table'

import IconPlus from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { DataTable } from '@/components/ui/table/data-table'

interface Props {
  columns: ColumnDef<AdditionalCost>[]
}

export const AccountingAdditionalCostsTableSkeleton = ({ columns }: Props) => {
  const skeletonColumns = columns.map((column) => ({
    ...column,
    cell: () => (
      <Skeleton className="h-4 w-20 !bg-slate-300 dark:!bg-slate-700" />
    ),
  })) as ColumnDef<unknown>[]

  return (
    <DataTable
      hasActionColumn
      title="Additional Costs"
      searchColumn="username"
      columns={skeletonColumns}
      data={Array.from({ length: 10 }).map(() => '')}
      extra={
        <Button disabled>
          <IconPlus />
          Add Additional costs
        </Button>
      }
    />
  )
}
